// Updated CommunityInvite.js with user search

import React, { useState, useEffect } from 'react';
import { Container, Card, Alert, Spinner, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getCommunity } from '../../services/communityService';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import UserSearchInvite from './UserSearchInvite';

function CommunityInvite() {
  const { communityId } = useParams();
  const { isAdminOfCommunity } = useAuth();
  const navigate = useNavigate();

  const [community, setCommunity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [inviteCount, setInviteCount] = useState(0);

  useEffect(() => {
    async function fetchCommunityDetails() {
      if (!communityId) return;
      
      try {
        setLoading(true);
        const communityData = await getCommunity(communityId);
        if (communityData) setCommunity(communityData);
      } catch (error) {
        setError("Napaka pri pridobivanju podatkov o skupnosti");
      } finally {
        setLoading(false);
      }
    }
    
    fetchCommunityDetails();
  }, [communityId]);

  const isAdmin = isAdminOfCommunity(parseInt(communityId));

  useEffect(() => {
    if (!loading && !isAdmin) {
      navigate('/', { replace: true });
    }
  }, [loading, isAdmin, navigate]);

  const handleInviteSent = (invitedUser) => {
    setInviteCount(prev => prev + 1);
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }


  return (
    <Container className="py-5">
      <Card className="shadow border-0 rounded-4">
        <Card.Body className="p-4">
          <div className="d-flex align-items-center mb-4">
            <Button
              variant="link"
              className="p-0 me-3 text-decoration-none"
              onClick={() => navigate(`/manage-community/${communityId}`)}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Nazaj
            </Button>
            <h3 className="mb-0">Povabi v skupnost: {community?.name}</h3>
          </div>

          {error && <Alert variant="danger">{error}</Alert>}

          {inviteCount > 0 && (
            <Alert variant="success">
              Poslanih povabil: {inviteCount}
            </Alert>
          )}

          <Alert variant="info" className="d-flex align-items-start">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2 mt-1" />
            <div>
              <p className="mb-2"><strong>Povabite uporabnike v vaso skupnost:</strong></p>
              <ul className="mb-0">
                <li>Iscite obstojecega uporabnika po imenu</li>
                <li>Vnesite tocen e-postni naslov za povabilo</li>
                <li>Uporabite e-posto za povabilo novih uporabnikov</li>
              </ul>
            </div>
          </Alert>

          <UserSearchInvite
            communityId={communityId}
            onInviteSent={handleInviteSent}
          />
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CommunityInvite;
